import { useState } from "react";

/** ダイアログの状態管理用hook */
const useDialog = () => {
  /**
   *  ダイアログ状態
   *  isOpen: ダイアログが開いているときに限りtrue
   *  onClose: ダイアログを閉じるときの挙動。
   * 　　　　　引数を設定すると、ダイアログが開いている時には閉じ、引数の値を(Promise経由で)返す
   */
  const [status, setStatus] = useState({
    isOpen: false,
    onClose: (v) => (e) => {},
  });

  /** ダイアログを開く */
  const open = async () => {
    return new Promise((resolve) => {
      setStatus((prev) => ({
        isOpen: true,
        onClose: (v) => (e) => resolve(v),
      }));
    }).then((v)=> {
      setStatus((prev) => ({
        isOpen: false,
        onClose: (v) => (e) => {},
      }))
      return(v);
    })
  };

  return {
    isOpen: status.isOpen,
    onClose: status.onClose,
    open
  };
};

export default useDialog;
